export const downloadJson = (fileName: string, jsonContent: string) => {
  const dataStr = `data:text/json;charset=utf-8,${jsonContent}`;
  const downloadAnchorNode = document.createElement("a");
  downloadAnchorNode.setAttribute("href", dataStr);
  downloadAnchorNode.setAttribute("download", `${fileName}.json`);
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
};


//Exports a particular validation to a file of given type zip or csv
export const appValidationExportUtils = (
  data: string,
  name: string,
  ext: string
) => {
  try {
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", name.concat(".", ext));
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.log(error);
  }
};
